import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { InfiniteScrollCustomEvent } from '@ionic/angular';
import { InvitePage } from 'src/app/pages';
import {
  CapacitorService,
  FirebaseService,
  EventsService,
  IonicService,
  CacheService,
  HttpService
} from 'src/app/services';

@Component({
  selector: 'tab-friends',
  templateUrl: './friends.tab.html',
  styleUrls: ['./friends.tab.scss'],
})
export class FriendsTab implements OnInit {

  data: any;
  sync: any;
  friends: any = [];
  count: number = 0;

  //----------------------------------------------------------------------------
  // Constructor
  //----------------------------------------------------------------------------

  constructor(
    public capacitor: CapacitorService,
    public firebase: FirebaseService,
    public ref: ChangeDetectorRef,
    public events: EventsService,
    public ionic: IonicService,
    public cache: CacheService,
    public http: HttpService,
    public zone: NgZone,
  ) { }

  //----------------------------------------------------------------------------
  // Initialize
  //----------------------------------------------------------------------------

  async ngOnInit() {
    this.firebase.setScreen('Friends');
    this.events.subscribeEvent('home', (sort) => { this.getData(); });
    this.getCache();
  }

  ngOnDestroy() {
    this.events.destroyEvent('home');
  }

  //----------------------------------------------------------------------------
  // Get Data
  //----------------------------------------------------------------------------

  async getCache() {
    this.zone.run(async () => {
      this.data = await this.cache.getCache('friends');
      this.infiniteScroll();
      this.getData();
    });
  }

  async getData() {
    this.zone.run(async () => {
      this.data = await this.http.getRequest('/me/friends', 'friends');
      this.capacitor.premium = this.data?.premium;
      this.infiniteScroll();
    });
  }

  //----------------------------------------------------------------------------
  // Get Pages
  //----------------------------------------------------------------------------

  async openInvite() {
    this.firebase.setEvent('friends_invite');
    this.ionic.openPage(InvitePage);
  }

  //----------------------------------------------------------------------------
  // Infinite Scroll
  //----------------------------------------------------------------------------

  private infiniteScroll() {
    this.zone.run(async () => {
      this.count = 0;
      this.friends = [];
      if (this.data['friends'] && this.data['friends'].length >= 50) {
        for (this.count = 0; this.count < 20; this.count++) {
          this.friends.push(this.data['friends'][this.count]);
        }
      } else {
        this.friends = this.data['friends'];
      }
      this.ref.detectChanges();
    });
  }

  async doInfinite(ev: Event) {
    let extra = this.count + 10;
    if (this.data['friends'].length >= extra) {
      for (this.count = this.count; this.count < extra; this.count++) {
        this.friends.push(this.data['friends'][this.count]);
      }
    } else {
      (ev as InfiniteScrollCustomEvent).target.disabled = true;
    }
    (ev as InfiniteScrollCustomEvent).target.complete()
  }
}